<template>
  <section class="section">
    <div class="sectionCnt">
      <img src="../assets/coming-soon-character.png"
        class="nunuLili">
      <img src="../assets/logo.png" class="logo">
      <img src="../assets/coming-soon.png" class="comingSoon">
      <div>
        <a
          href="https://nutrilite.co.id/bodykey/mulai-sekarang/challenge-your-limit-with-bodykey-1">
          Click for more info!</a>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'home',
  components: {},
  data() {
    return {};
  },
  created() {},
  destroyed() {},
  methods: {
    doNothing() {},
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.section{
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  padding: 0;
  background-color: #d5f4e8;
  overflow-y: auto;
  @media (min-height: 840px) {
    display: flex;
    align-items: center;
  }
  @media (max-width: 560px) and (min-height: 780px) {
    display: flex;
    align-items: center;
  }
  .sectionCnt{
    width: 420px;
    margin: 0 auto;
    text-align: center;
    padding-bottom: 40px;
    @media (min-height: 840px) {
      padding-bottom: 0;
    }
    @media (max-width: 560px) {
      width: auto;
      margin: 0 20px;
    }
    @media (max-width: 560px) and (min-height: 780px) {
      padding-bottom: 0;
    }
    .nunuLili{
      width: 300px; height: auto;
      margin: -46px auto 40px;
      @media (min-height: 800px) {
        margin-top: 0;
      }
      @media (max-width: 560px) {
        width: 260px;
      }
    }
    .logo{
      margin: 0 0 20px;
      width: 100%;
    }
    .comingSoon{
      width: 320px;
      margin: 0 0 40px;
      @media (max-width: 560px) {
        width: 300px;
      }
    }
    a{
      color: #fff;
      background-color: #00c08a;
      // background-color: #78C90E;
      display: inline-block;
      padding: 8px 20px 6px;
      border-radius: 50px;
      font-weight: bold;
      transition: all .3s ease;
      &:hover{
        background-color: #03a376;
      }
    }
  }
}
</style>
